const TOP_HIGHLIGHT_ID = process.env.TOP_HIGHLIGHT_ID || 'top-highlight'
export const env = {
  TOP_HIGHLIGHT_ID,
}